/* eslint-disable */
import React from 'react';

const HIGH_PRIORITY = 'needsBeforeOthers';
const REGULAR_PRIORITY = 'needs';

/**
 * Get name for static field with dependencies
 * @param  {number} priority=0
 * @returns {'needs'|'needsBeforeOthers'} field name
 */
const getPriorityFieldName = (priority = 0) => {
    if (priority > 0) {
        return HIGH_PRIORITY;
    }

    return REGULAR_PRIORITY;
};

export const priorityOfCall = {
    HIGH: 1,
    REGULAR: 0,
};

/**
 * HOC for fetching component data at the ssr part
 * @param  {function[]} dependencies - list of functions
 * @param  {number} priority - priority of call
 */
export default (dependencies, priority) => (WrappedComponent) => {
    const Wrapper = (props) => <WrappedComponent {...props} />;

    const priorityFieldName = getPriorityFieldName(priority);

    Wrapper[HIGH_PRIORITY] = WrappedComponent[HIGH_PRIORITY];
    Wrapper[REGULAR_PRIORITY] = WrappedComponent[REGULAR_PRIORITY];

    Wrapper[priorityFieldName] = [
        ...(Array.isArray(WrappedComponent[priorityFieldName])
            ? WrappedComponent[priorityFieldName]
            : []),
        ...dependencies,
    ];

    return Wrapper;
};
